import { Loader } from "rsuite";
import { ProductData } from ".";
import { numberFormatter } from "../../utils";
import { useEffect, useState } from "react";
import { Checkbox, Button } from "rsuite";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";

type Props = {
	loading: boolean;
	selectedProduct: ProductData | null;
	skuData: any;
	updateMaterials: any;
	materialList: any;
	handleSave: any;
};

const ProductGroupDetails = ({
	loading,
	selectedProduct,
	skuData: res,
	materialList,
	updateMaterials,
	handleSave,
}: Props) => {
	const [billingQtyColSpan, setBillingQtyColSpan] = useState<number>(1);
	const [showDetails, setShowDetails] = useState(false);

	useEffect(() => {
		if (res) {
			setBillingQtyColSpan(
				res.vendorList.reduce((a: any, b: any) => {
					return a + res.productId[b].length;
				}, 0)
			);
		}
	}, [res]);

	const handleCheckboxSelection = (
		materialId: any,
		vendor: any,
		currMaterialList: any
	) => {
		updateMaterials(materialId, currMaterialList, vendor);
	};

	return (
		<div className="w-full h-full">
			{loading ? (
				<Loader
					className="w-full h-full relative"
					size="md"
					inverse
					center
					content="loading..."
				/>
			) : (
				res &&
				Object.keys(res).length > 0 && (
					<div className="w-full h-full flex flex-col justify-between">
						<div className="common-table-header-row">
							<span className="common-table-header">
								Additional Product Group Level Details
							</span>
							<button
								className="savingButton"
								onClick={() => {
									handleSave();
								}}
							>
								Save
							</button>
						</div>
						<div className="basis-[85%] grow overflow-auto w-full">
							<table className="common-table-ui">
								<thead>
									<tr>
										<th rowSpan={5}>
											Product <br />
											Group Id
										</th>
										<th rowSpan={5}>
											Product Group
											<br />
											Description
										</th>
										<th rowSpan={5}>District</th>
										<th>Supplier</th>
										{res?.vendorList?.map(
											(vendor: string, index: number) => {
												return (
													<th
														key={vendor + index}
														className="uppercase"
														colSpan={
															res.productId[
																vendor
															].length
														}
													>
														{vendor}
													</th>
												);
											}
										)}
										{/* <th colSpan={billingQtyColSpan}>Billing Qty.</th> */}
									</tr>
									{/* <tr>
                                    {res?.vendorList?.map((vendor: string, index: number) => {
                                        return (<th key={vendor + index} className="uppercase" colSpan={res.productId[vendor].length}>{vendor}</th>)
                                    })}
                                </tr> */}
									<tr>
										<th
											style={{
												cursor: "pointer",
												userSelect: "none",
											}}
											onClick={() =>
												setShowDetails((prev) => !prev)
											}
										>
											<div className="flex">
												{/* Icon before the text */}
												{showDetails ? (
													<MinusRoundIcon className="plusIcon" />
												) : (
													<PlusRoundIcon className="plusIcon" />
												)}
												<div>Material</div>
											</div>
										</th>
										{res?.vendorList?.map((vendor: any) => {
											let v: keyof typeof res.productId =
												vendor;
											return res?.productId[v]?.map(
												(item: any, index: number) => {
													return (
														<th
															key={
																vendor +
																"_" +
																item.material +
																"_" +
																index
															}
														>
															<Checkbox
																color="green"
																defaultChecked={
																	item.selectedFlag
																}
																onChange={(
																	value: any
																) => {
																	item.selectedFlag =
																		item.selectedFlag
																			? 0
																			: 1;
																	handleCheckboxSelection(
																		item.material,
																		vendor,
																		res?.productId
																	);
																}}
															>
																<span className="">
																	{
																		item.material
																	}
																</span>
															</Checkbox>
														</th>
													);
												}
											);
										})}
									</tr>
									{showDetails && (
										<>
											<tr>
												<th
													style={{
														whiteSpace: "nowrap",
													}}
												>
													Net Cost
												</th>
												{res?.vendorList?.map(
													(vendor: any) => {
														let v: keyof typeof res.productId =
															vendor;
														return res?.productId[
															v
														]?.map(
															(
																item: any,
																index: number
															) => {
																return (
																	<>
																		<th
																			style={{
																				fontWeight:
																					"500",
																			}}
																		>
																			$
																			{numberFormatter(
																				item.net_cost_per_unit,
																				1
																			)}
																			/Unit
																		</th>
																	</>
																);
															}
														);
													}
												)}
											</tr>
											<tr>
												<th
													style={{
														whiteSpace: "nowrap",
													}}
												>
													Sell Price
												</th>
												{res?.vendorList?.map(
													(vendor: any) => {
														let v: keyof typeof res.productId =
															vendor;
														return res?.productId[
															v
														]?.map(
															(
																item: any,
																index: number
															) => {
																return (
																	<>
																		<th
																			style={{
																				fontWeight:
																					"500",
																			}}
																		>
																			$
																			{numberFormatter(
																				item.revenue_per_unit,
																				1
																			)}
																			/Unit
																		</th>
																	</>
																);
															}
														);
													}
												)}
											</tr>
										</>
									)}
									<tr>
										<th colSpan={billingQtyColSpan + 1}>
											Billing Quantity
										</th>
									</tr>
								</thead>
								<tbody>
									{res.data.map((d: any, index: number) => {
										return selectedProduct?.district !=
											d.district ? (
											<tr key={d.district}>
												{index === 0 && (
													<>
														<td
															rowSpan={
																res.data.length
															}
														>
															{
																selectedProduct?.product_group_id
															}
														</td>
														<td
															rowSpan={
																res.data.length
															}
														>
															{
																selectedProduct?.product_group_description
															}
														</td>
													</>
												)}
												{index === 1 &&
													res.data[0].district ===
														selectedProduct?.district && (
														<>
															<td
																rowSpan={
																	res.data
																		.length -
																	1
																}
															>
																{
																	selectedProduct?.product_group_id
																}
															</td>
															<td
																rowSpan={
																	res.data
																		.length -
																	1
																}
															>
																{
																	selectedProduct?.product_group_description
																}
															</td>
														</>
													)}
												<td colSpan={2}>
													{d.district}
												</td>
												{res.vendorList.map(
													(
														vendor: any,
														index: number
													) => {
														// let v: keyof typeof res.productId = vendor;
														if (d[vendor]) {
															let pIdList: any =
																Object.keys(
																	d[vendor]
																);
															return (
																pIdList &&
																pIdList.map(
																	(
																		pId: string
																	) => {
																		let num: any =
																			d[
																				vendor
																			][
																				pId
																			]
																				? numberFormatter(
																						d[
																							vendor
																						][
																							pId
																						] *
																							1,
																						0
																				  )
																				: "-";
																		return (
																			<td
																				className={`${
																					num ==
																						"-" ||
																					num ==
																						0
																						? "bg-[#bebebe]"
																						: "bg-[#d0ebb3] text-black"
																				}`}
																				key={
																					vendor +
																					"_" +
																					pId
																				}
																			>
																				{
																					num
																				}
																			</td>
																		);
																	}
																)
															);
														} else {
															return (
																<td
																	key={
																		vendor +
																		"_" +
																		index
																	}
																>
																	-
																</td>
															);
														}
													}
												)}
											</tr>
										) : (
											""
										);
									})}
								</tbody>
							</table>
						</div>
						<div className="flex justify-stretch gap-4 items-center basis-[7%] w-full grow-0 text-black mt-2 ">
							<div className=" flex flex-row  items-center justify-between gap-4 basis-1/2 px-[1vh] py-[0.5vh] bg-white border border-[#bebebe]">
								<span className="font-semibold textNormal">
									Total National Sales
								</span>
								<span className="font-bold textLarge">
									{numberFormatter(
										selectedProduct?.total_national_sales,
										0,
										"$"
									)}
								</span>
							</div>
							<div className=" flex flex-row  items-center justify-between gap-4 basis-1/2 px-[1vh] py-[0.5vh] bg-white border border-[#bebebe]">
								<span className="font-semibold textNormal">
									Average National GM (%)
								</span>
								<span className="font-bold textLarge">
									{numberFormatter(
										selectedProduct?.average_national_gm ||
											0,
										2
									) + "%"}
								</span>
							</div>
						</div>
					</div>
				)
			)}
		</div>
	);
};

export default ProductGroupDetails;
